import React from "react";
import { X } from "lucide-react";
import { INK, INK_2, INK_3, LINE, BG } from "../../Bureau/bureauTokens";

function rgba(hex, a) {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
}

// .pl-legend-chip — bascule d'affichage d'un planning collaborateur (ou
// d'une salle) : point de couleur + nom + rôle d'accès, estompé si masqué.
// `onRemove` (facultatif) ajoute un petit "×" pour retirer un collègue
// ajouté manuellement — absent pour les puces non supprimables (ex. Google
// Calendar).
function PlanningLegendChip({ color, name, roleLabel, active, onClick, onRemove }) {
  return (
    <span
      className="inline-flex items-center gap-1 transition-opacity"
      style={{
        padding: "4px 4px 4px 9px",
        border: `1px solid ${active ? color : LINE}`,
        borderRadius: 20,
        background: active ? rgba(color, 0.1) : "#fff",
        opacity: active ? 1 : 0.55,
      }}
    >
      <button onClick={onClick} className="inline-flex items-center gap-1.5 text-[11px]" style={{ color: active ? INK : INK_2 }}>
        <span style={{ width: 8, height: 8, borderRadius: "50%", background: color, flexShrink: 0 }} />
        <span className="font-semibold">{name}</span>
        {roleLabel && (
          <span
            className="text-[9.5px] font-bold uppercase"
            style={{ color: INK_3, background: BG, padding: "1px 5px", borderRadius: 5, letterSpacing: 0.3 }}
          >
            {roleLabel}
          </span>
        )}
      </button>
      {onRemove && (
        <button
          onClick={onRemove}
          title="Retirer"
          className="flex items-center justify-center flex-shrink-0"
          style={{ width: 16, height: 16, borderRadius: "50%", color: INK_3 }}
        >
          <X size={10} />
        </button>
      )}
    </span>
  );
}

export default PlanningLegendChip;
